module.exports = __webpack_public_path__ + "img/gz.b9b27ca6.png";